import React, {Component} from 'react';
import {UrlListModal} from "./UrlListModal";
import {UrlAlertTooltip} from "./UrlAlertTooltip";
import {FaIcon} from "../FaIcon";

export class UrlListButton extends Component {
    constructor(props) {
        super(props);

        // Check if the URL contains the parameter that indicates modal display
        const params = new URLSearchParams(this.props.location.search);
        const shouldShowModal = params.get('urls_modal') !== null && params.get('urls_modal') === this.props.businessUnitId.toString();

        this.state = {
            modal: shouldShowModal,
        };

        this.toggle = this.toggle.bind(this);
        this.hasAlert = this.hasAlert.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    hasAlert() {
        return this.props.downUrlsCount > 0;
    }

    _hasUrls() {
        return this.props.hasUrls;
    }

    // rendering

    renderModal() {
        if (this.state.modal) {
            return <UrlListModal isOpen={this.state.modal} toggle={this.toggle}
                                 businessUnitAdAccountId={this.props.businessUnitAdAccountId}
                                 businessUnitId={this.props.businessUnitId}
                                 title={this.props.title}
                                 hasAlert={this.hasAlert()}
                                 downUrlsCount={this.props.downUrlsCount}
            />;
        } else {
            return null;
        }
    }

    renderButton() {
        if (this.hasAlert()) {
            return (
                <button onClick={this.toggle} className="bu-cell-button broken-url">
                    <FaIcon iconName="unlink"/>
                    <UrlAlertTooltip downUrlsCount={this.props.downUrlsCount}/>
                </button>
            )
        } else if(this._hasUrls()) {
            return (
                <button onClick={this.toggle} className="bu-cell-button url-modal">
                    <FaIcon iconName="link"/>
                </button>
            )
        } else {
            return (<FaIcon iconName="link" className="bu-cell-icon"/>)
        }
    }

    render() {
        return (
            <div>
                {this.renderButton()}
                {this.renderModal()}
            </div>
        );
    }
}

